export const COOKIE_NAME_LANGUAGE = "_wf_language";
export const COOKIE_NAME_COUNTRY = "_wf_country";
export const COOKIE_ERROR = "_wf_error";
